// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Sua-T","list":"styles_list__c0mxh","cityName":"styles_cityName__2q6r2","text":"styles_text__rK55W","padding":"styles_padding__Ud+IZ"};